/**
 * Cadeau offert (app cimalp-discounts) : le client peut le retirer, puis le
 * reprendre.
 *
 * Le refus est noté dans l'attribut de panier `_cadeaux_refuses` (clés d'offres
 * séparées par des virgules), lu par l'app (boutique et checkout) et par
 * snippets/cim-cart-progress.liquid. Il suit le panier : autre onglet, autre
 * appareil, checkout. Il disparaît avec le panier, après la commande.
 *
 * - « Retirer » sur la ligne cadeau (`data-cim-gift-refuse` = clé de ligne,
 *   `data-cim-gift-offer` = clé de l'offre) : retrait de la ligne ET refus dans
 *   la même requête, sinon l'app remettrait le cadeau entre les deux.
 * - « Ajouter mon cadeau » (`data-cim-gift-restore` = clé de l'offre) : retire
 *   la clé de l'attribut ; l'app remet le cadeau à sa lecture suivante du panier.
 *
 * Délégation sur le document : le panier est re-rendu à chaque modification.
 */
(() => {
	const ATTRIBUTE = '_cadeaux_refuses';
	const root = () => window.Shopify?.routes?.root || '/';

	const parseKeys = (value) =>
		String(value || '')
			.split(',')
			.map((key) => key.trim())
			.filter(Boolean);

	/** Refus actuels, relus sur le panier : l'app a pu en inscrire depuis le rendu. */
	async function currentRefusals() {
		const response = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } });
		if (!response.ok) throw new Error(`cart.js ${response.status}`);
		const cart = await response.json();
		return parseKeys(cart.attributes?.[ATTRIBUTE]);
	}

	/** Section du panier latéral à re-rendre avec la réponse, comme mm_cart.js. */
	function cartSectionId() {
		const section = document.querySelector('[data-cart], .mm-cart')?.closest('.shopify-section');
		return section?.id?.replace('shopify-section-', '') || '';
	}

	/** cart/update.js, par CartAPI (mm_cart.js) pour rafraîchir le panier et la pastille. */
	async function updateCart(body) {
		const sectionId = cartSectionId();
		if (sectionId) body.sections = sectionId;
		/* global CartAPI */
		if (typeof CartAPI !== 'undefined' && typeof CartAPI.request === 'function') {
			return CartAPI.request('POST', 'cart/update.js', body);
		}
		const response = await fetch(`${root()}cart/update.js`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify(body),
		});
		if (!response.ok) throw new Error(`cart/update.js ${response.status}`);
		return response.json();
	}

	async function run(button, buildBody) {
		if (button.disabled) return;
		button.disabled = true;
		button.classList.add('mm-loading');
		try {
			await updateCart(buildBody(await currentRefusals()));
		} catch (error) {
			console.warn('[cim-gift]', error.message);
			button.disabled = false;
			button.classList.remove('mm-loading');
		}
	}

	document.addEventListener('click', (event) => {
		const refuse = event.target.closest('[data-cim-gift-refuse]');
		if (refuse) {
			event.preventDefault();
			const lineKey = refuse.dataset.cimGiftRefuse;
			const offerKey = refuse.dataset.cimGiftOffer;
			if (!lineKey || !offerKey) return;
			run(refuse, (refusals) => ({
				updates: { [lineKey]: 0 },
				attributes: { [ATTRIBUTE]: [...new Set([...refusals, offerKey])].join(',') },
			}));
			return;
		}

		const restore = event.target.closest('[data-cim-gift-restore]');
		if (restore) {
			event.preventDefault();
			const offerKey = restore.dataset.cimGiftRestore;
			if (!offerKey) return;
			run(restore, (refusals) => ({
				attributes: { [ATTRIBUTE]: refusals.filter((key) => key !== offerKey).join(',') },
			}));
		}
	});
})();
